import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {
        maxStorage : '',
        usingStorage : ''
    },
};

const storageSlice = createSlice({
    name: 'storage',
    initialState,
    reducers: {
        funGetStorage(state, action){
            const data  = action.payload;
    state.data = { ...data };
        }
    },
});

export const storageActions = storageSlice.actions;
export default storageSlice.reducer;